var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("p", [_vm._v("已选" + _vm._s(_vm.checkList.length) + "条;")]),
          _vm._v(" 分配至："),
          _c(
            "el-tag",
            {
              staticClass: "add-per-input",
              attrs: {
                title: "选择员工",
                closable: _vm.searchMenNames.length === 0 ? false : true,
                type: "medium",
                effect: "plain"
              },
              on: {
                close: _vm.searchCloseTag,
                click: function($event) {
                  return _vm.clickAddMember(true)
                }
              }
            },
            [
              _vm.searchMenNames.length === 0
                ? _c("span", [_vm._v("选择员工")])
                : _vm._e(),
              _vm._l(_vm.searchMenNames, function(item, index) {
                return _c("span", { key: index }, [
                  _vm._v(_vm._s(item.name)),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.searchMenNames.length > 1 &&
                            index != _vm.searchMenNames.length - 1,
                          expression:
                            "\n            searchMenNames.length > 1 && index != searchMenNames.length - 1\n          "
                        }
                      ]
                    },
                    [_vm._v(",")]
                  )
                ])
              })
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.handleDefine }
                },
                [_vm._v("执行")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("StaffTree", {
        attrs: {
          title: _vm.treeTitle,
          dialogVisibleTree: _vm.dialogVisibleTree,
          currentSelectMember: _vm.currentSelectMember
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }